import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { UntypedFormGroup, NgModel, UntypedFormBuilder } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { ActivatedRoute } from "@angular/router";
import { User } from "@core/models";
import {
  NgbDate,
  NgbDateParserFormatter,
  NgbDateStruct,
  NgbInputDatepicker,
  NgbModal,
} from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import {
  BookService,
  BookedService,
  CompanyService,
  ExcelService,
  MediaService,
  NgxToastrService,
  TravelService,
  UserService,
  UtilsService,
} from "@services";
import { DialogAssignProjectComponent } from "@shared/component/dialog-assign-project/dialog-assign-project.component";
import { AppState } from "app/app.reducer";
import { ViewPdfModalComponent } from "app/modules/businessEntities/user/user-detail/view-pdf-modal/view-pdf-modal.component";
import * as moment from "moment";
import { forkJoin, of, Subject, Subscription } from "rxjs";
import { catchError, debounceTime, finalize, map, take } from "rxjs/operators";
import swal from "sweetalert2";
import { TravelAddUserComponent } from "./travel-add-user/travel-add-user.component";
import { saveAs } from "file-saver";
import JSZip from "jszip";
import { Location } from "@angular/common";
import { TravelBookingsModalComponent } from "./travel-bookings-modal/travel-bookings-modal.component";

@Component({
  selector: "app-travel-container",
  templateUrl: "./travel-container.component.html",
  styleUrls: ["./travel-container.component.scss"],
})
export class TravelContainerComponent implements OnInit, OnDestroy {
  travels: any[] = [];
  form: UntypedFormGroup;
  @Input() uuid?: string;
  @Input() companyUuid?: string;
  @Input() isEmployee?: string;
  @Input() isLoading?: boolean;
  @Input() isCompanyBookeds?: boolean;
  isLoadingTravel?: boolean;
  uuidUser: string;
  hasCleared = false;
  types = [
    {
      name: "Hotel",
      value: "hotel",
    },
    {
      name: "Vuelo",
      value: "flight",
    },
    {
      name: "Tren",
      value: "train",
    },
    {
      name: "Coche de alquiler",
      value: "car",
    },
    {
      name: "Transfer",
      value: "transfer",
    },
    {
      name: "Taxi",
      value: "taxi",
    },
    {
      name: "Otro",
      value: "other",
    },
  ];
  isAdmin = false;
  subscriptions: Subscription[] = [];
  user: User;
  employeeUuid: string;
  travelPage = 1;
  travelPageSize = 6;
  travelTotalDocs = 0;
  travelTotalPages = 0;
  private travelPagesCache = new Map<string, any>();
  private titleFilterSubject = new Subject<void>();
  @ViewChild(NgModel) datePick: NgModel;
  @ViewChild("paginator") paginator: MatPaginator;
  @ViewChild("createdAtRange") createdAtRange: ElementRef;
  createdFromDate: any;
  createdToDate: any;
  @ViewChild("d2") createdInput: NgbInputDatepicker;
  hoveredDate: NgbDateStruct;
  travelPagination = {};
  companyImage = "";
  companyUuidSaved: string;
  
  constructor(
    private travelService: TravelService,
    private translateService: TranslateService,
    private ngbDateParser: NgbDateParserFormatter,
    private bookingService: BookedService,
    private modalService: NgbModal,
    private translate: TranslateService,
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private ngxToastrService: NgxToastrService,
    private userService: UserService,
    public utilsService: UtilsService,
    private excelService: ExcelService,
    private dialog: MatDialog,
    private bookService: BookService,
    private formBuilder: UntypedFormBuilder,
    private _location: Location,
    private mediaService: MediaService,
    private companyService: CompanyService,
  ) {
    this.form = this.formBuilder.group({
      title: "",
      total: 0,
    });
    this.isCompanyBookeds =
      this.route.snapshot.routeConfig.path === "projects" ||
      this.route.snapshot.routeConfig.path === ":id/projects";
  }

  ngOnInit() {
    this.companyUuidSaved = this.companyUuid;
    this.subscriptions.push(
      this.titleFilterSubject
        .pipe(
          debounceTime(400)
        )
        .subscribe(() => {
          this.travelPage = 1;

          if (this.paginator) {
            this.paginator.pageIndex = 0;
          }

          this.loadTravels();
        })
    );
    this.subscriptions.push(
      this.store.select("auth").subscribe((s: any) => {
        if (s.user != null) {
          if (s.user.type?.toUpperCase() !== "USER") {
            this.isAdmin = true;
            if (s.user.type?.toUpperCase() === "COMPANY") {
              this.uuid = s.user.uuid;
              this.companyUuid = this.route.snapshot.paramMap.get("uuid")
                ? s.user.uuid
                : s.user.companyUuid;
              this.uuidUser = this.route.snapshot.paramMap.get("uuid")
                ? this.route.snapshot.paramMap.get("uuid")
                : s.user.uuid;
            } else {
              const companyId = this.route.snapshot.paramMap.get("id") || s.user.companyUuid;
              if (companyId) {
                this.companyUuid = companyId;
              } 
              this.uuidUser = this.route.snapshot.paramMap.get("uuid")
                ? this.route.snapshot.paramMap.get("uuid")
                : s.user.uuid;
            }
          } else {
            this.uuidUser = s.user.uuid;
          }
          if (this.uuidUser) {
            this.userService.getUser(this.uuidUser).subscribe((u) => {
              if(u){
                this.user = u;
              }
              if(u && u.companyUuid){
                this.companyUuid = u.companyUuid;
              }
              if(this.companyUuid){
                this.loadCompanyImg(this.companyUuid, this.uuidUser)
              }
            }, (error) => {})
          }
          if(s.user.accessType.toLowerCase() === "user"){
            this.bookService.clearCache();
            this.loadTravels();
          }else{
            this.loadTravels();
          }
        }
      })
    );
   
    if (this.companyUuid) {
      const userUuid = this.uuidUser || this.uuid;
      this.loadCompanyImg(this.companyUuid, userUuid);
    }
  }

  get f() {
    return this.form.controls;
  }
 
  loadCompanyImg(companyUuid?: string, userUuid?: string){
    this.companyService
      .getCompanyImage(companyUuid, userUuid)
      .subscribe((img: string) => {
        this.mediaService.getMedia(img).subscribe((s) => {
          const reader = new FileReader();
          reader.readAsDataURL(s);
          let base64data;
          reader.onloadend = () => {
            base64data = reader.result;
            this.companyImage = base64data;
          };
        });
      });
  }

  /**
   * Clears the params object and call the API service with no params
   */
  clearFilters(): void {
    this.f.title.setValue('');

    this.createdFromDate = null;
    this.createdToDate = null;

    if (this.createdAtRange?.nativeElement) {
      this.createdAtRange.nativeElement.value = '';
    }

    this.hasCleared = true;
    this.travelPage = 1;

    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }

    this.loadTravels();
  }

  getFilters() {
    return [this.f.title.value, this.f.total.value];
  }

  transformTextType(type: string) {
    let ty = type;
    this.types.forEach((t) => {
      if (t.value === type) {
        ty = t.name;
      }
    });
    return ty;
  }

  transformDate(date: Date) {
    return this.translate.currentLang === "es"
      ? moment(date).format("DD/MM/YYYY")
      : moment(date).format("MM/DD/YYYY");
  }

  onEdit(travel: any) {
    const data: any = {
      create: true,
      isOnlyCreate: true,
      editTravelData: travel,
      previousBooking: true,
    };

    if (this.uuidUser) {
      data.userUuid = this.uuidUser;
    }
    if (this.companyUuid) {
      data.companyUuid = this.companyUuid;
    }
    const modalRef = this.dialog.open(DialogAssignProjectComponent, {
      data,
      panelClass: "new-dialog",
    });
    modalRef.afterClosed().subscribe((result) => {
      if (result != null) {
        if (this.companyUuid) {
          result.travelData["companyUuid"] = this.companyUuid;
        }
        if (result.travelData["endDate"] === "" && result.travelData["initDate"] === "") {
          delete result.travelData["endDate"];
          delete result.travelData["initDate"];
        }
        this.subscriptions.push(
          this.travelService
            .putTravel(result.travelData, travel.uuid)
            .subscribe(
              () => {
                this.subscriptions.push(
                  this.translate
                    .get(`project.my-projects.edited`)
                    .subscribe((resp) => {
                      this.ngxToastrService.typeSuccess(null, resp);
                      this.loadTravels(true);
                    })
                );
              },
              (err) => {
                this.subscriptions.push(
                  this.translateService
                    .get("common.error")
                    .subscribe((resp) => {
                      this.ngxToastrService.typeInfo(resp, err.error.message);
                    })
                );
              }
            )
        );
      }
    });
  }

  onGetPDF(booked: any, type: any) {
    const downloadRequests: any[] = [];
  
    if (type === "hotel" || type === "bookingApiReference") {
      if (Array.isArray(booked.bonoFileUrl)) {
        for (let fileUrl of booked.bonoFileUrl) {
          downloadRequests.push(this.bookingService.getBookedsPdf(fileUrl).pipe(take(1)));
        }
      }
  
    } else if (type === "custom-booking") {
      if (Array.isArray(booked.voucherFile)) {
        for (let file of booked.voucherFile) {
          const customUrl = `/media/${file.uuid}/custom`;
          downloadRequests.push(this.bookingService.getCustomBookingPdf(customUrl).pipe(take(1)));
        }
      }
    } else {
      if (Array.isArray(booked.voucherFileUrl)) {
        for (let fileUrl of booked.voucherFileUrl) {
          downloadRequests.push(this.bookingService.getBookedsPdf(fileUrl).pipe(take(1)));
        }
      }
    }
    if (downloadRequests.length > 0) {
      forkJoin(downloadRequests).subscribe(
        (responses) => {
          responses.forEach((res, index) => {
            const modalRef = this.modalService.open(ViewPdfModalComponent, {
              size: "lg",
              centered: true,
            });
            modalRef.componentInstance.blobUrl = URL.createObjectURL(res);
            if (type === "hotel" || type === "bookingApiReference") {
              modalRef.componentInstance.fileName = booked.apiReference || booked.bonoFileUrl[index];
            } else if (type === "custom-booking") {
              modalRef.componentInstance.fileName = booked.voucherFile[index]?.fileName || booked.voucherFile[index]?.uuid;
            } else {
              modalRef.componentInstance.fileName = booked.voucherFileUrl[index] || booked.voucherFile[index]?.fileName || booked.voucherFile[index]?.uuid;
            }
          });
        },
        () => {
          this.translateService
            .get(["common.error-pdf"])
            .pipe(take(1))
            .subscribe(() => {
              this.advicePdf();
            });
        }
      );
    }
  }

  advicePdf() {
    this.subscriptions.push(
      this.translateService
        .get(["common.generating-pdf", "common.generating-pdf-body"])
        .subscribe((result) => {
          swal.fire({
            title: result["common.generating-pdf"],
            text: result["common.generating-pdf-body"],
            imageUrl: "assets/img/svg/timePdf.svg",
            showCancelButton: false,
            showConfirmButton: false,
            showCloseButton: true,
            backdrop: true,
          });
        })
    );
  }

  hasPdf(expense: any) {
    if (
      expense.voucherFileUrl &&
      expense.voucherFileUrl !== "" &&
      expense.voucherFileUrl !== "/media/expense/undefined"
    ) {
      return true;
    } else {
      return false;
    }
  }

  missingCompanyUuid() {
    this.translateService
      .get(["common.error", "my-bookeds.user.no-company-uuid"])
      .subscribe((resp) => {
        this.ngxToastrService.typeInfo(
          resp["common.error"],
          resp["my-bookeds.user.no-company-uuid"]
        );
      });
  }

  addUser(travel: any) {
    const modalRef = this.modalService.open(TravelAddUserComponent, {
      size: "lg",
      centered: true,
    });
    modalRef.componentInstance.uuid = this.companyUuid;
    modalRef.componentInstance.uuidUser = this.uuidUser;
    modalRef.componentInstance.travel = travel;
    this.subscriptions.push(
      modalRef.componentInstance.sendInfo.subscribe(
        (dataModal) => {
          this.subscriptions.push(
            this.travelService.addItemTravel(dataModal, travel.uuid).subscribe(
              () => {
                this.subscriptions.push(
                  this.translate
                    .get(`project.my-projects.add-user.done`)
                    .subscribe((resp) => {
                      this.ngxToastrService.typeSuccess(null, resp);
                      setTimeout(() => {
                        this.loadTravels(true);
                      }, 3000);
                    })
                );
              },
              (err) => {
                this.subscriptions.push(
                  this.translate
                    .get(`project.my-projects.delete.error-cancel`)
                    .subscribe((resp) => {
                      this.ngxToastrService.typeInfo(resp, err.error.message);
                    })
                );
              }
            )
          );
        },
        (err) => {
          this.subscriptions.push(
            this.translate
              .get(`project.my-projects.delete.error-cancel`)
              .subscribe((resp) => {
                this.ngxToastrService.typeInfo(resp, err.error.message);
              })
          );
        }
      )
    );
  }

  onDelete(userUuid: string, travelUuid: string) {
    const body = {
      item: {
        type: "user",
        uuid: userUuid,
      },
      userUuid: userUuid,
    };
    this.subscriptions.push(
      this.travelService.removeItemTravel(body, travelUuid).subscribe(
        (s) => {
          this.subscriptions.push(
            this.translate
              .get(`project.my-projects.delete-user.done`)
              .subscribe((resp) => {
                this.ngxToastrService.typeSuccess(null, resp);
                setTimeout(() => {
                  this.loadTravels(true);
                }, 3000);
              })
          );
        },
        (err) => {
          this.subscriptions.push(
            this.translate
              .get(`project.my-projects.delete.error-cancel`)
              .subscribe((resp) => {
                this.ngxToastrService.typeInfo(resp, err.error.message);
              })
          );
        }
      )
    );
  }

  onCancel(uuid: string) {
    this.translate
      .get([
        `project.my-projects.delete.title`,
        "project.my-projects.delete.question",
        "common.confirm",
        "common.cancel",
      ])
      .subscribe((result) => {
        swal
          .fire({
            title: result[`project.my-projects.delete.title`],
            text: result["project.my-projects.delete.question"],
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#0CC27E",
            cancelButtonColor: "#FF586B",
            confirmButtonText: result["common.confirm"],
            cancelButtonText: result["common.cancel"],
            customClass: {
              confirmButton: "btn btn-success btn-raised",
              cancelButton: "btn btn-danger btn-raised mr-5",
            },
            buttonsStyling: false,
          })
          .then((action) => {
            if (action.value) {
              this.subscriptions.push(
                this.travelService.deleteTravel(uuid).subscribe(
                  () => {
                    this.translate
                      .get(`project.my-projects.delete.canceled`)
                      .subscribe((resp) => {
                        this.loadTravels(true);
                        this.ngxToastrService.typeSuccess(null, resp);
                      });
                  },
                  (err) => {
                    if (
                      err.error.message ===
                      "There are some travel items attached to this travel"
                    ) {
                      this.translate
                        .get([`project.my-projects.delete.cannot-delete`])
                        .subscribe((resp) => {
                          this.ngxToastrService.typeInfo(
                            resp["project.my-projects.delete.cannot-delete"],
                            ""
                          );
                        });
                    } else {
                      this.translate
                        .get([`project.my-projects.delete.error-cancel`])
                        .subscribe((resp) => {
                          this.ngxToastrService.typeInfo(
                            resp["project.my-projects.delete.error-cancel"],
                            ""
                          );
                        });
                    }
                  }
                )
              );
            }
          });
      });
  }

  exportExcel(travel?) {
    const travelsToExport = travel ? [{ ...travel }] : this.travels.map(t => ({ ...t }));

    travelsToExport.forEach(t => t.title = (t.title || '').replace(/[*?:\\/\[\]]/g, '_'));
    travelsToExport.forEach(t => {
      if (Array.isArray(t.bookingFromModule) && Array.isArray(t.bookings)) {
        const idx = new Map<string, any>();
        t.bookings.forEach(b => {
          const key = (b?.bookedApiUuid || b?.uuid);
          if (key) idx.set(key, b);
        });

        t.bookingFromModule.forEach(bfm => {
          if (!bfm) return;
          const src = idx.get(bfm.uuid) || idx.get(bfm.bookedApiUuid);
          if (src?.userUuid && !bfm.userUuid) {
            bfm.userUuid = Array.isArray(src.userUuid) ? [...src.userUuid] : src.userUuid;
          }
        });
      }
    });

    const collectUuidsFromTravel = (t: any): string[] => {
      const set = new Set<string>();
      const pushFrom = (arr?: any[]) => {
        (arr || []).forEach(item => {
          const raw = item?.userUuid;
          const ids = Array.isArray(raw) ? raw : (raw ? [raw] : []);
          ids.forEach(id => id && set.add(id));
        });
      };
      pushFrom(t.bookings);
      pushFrom(t.customBookings);
      pushFrom(t.bookingFromModule);
      return Array.from(set);
    };

    const globalUuidSet = new Set<string>();
    travelsToExport.forEach(t => collectUuidsFromTravel(t).forEach(id => globalUuidSet.add(id)));
    const uuids = Array.from(globalUuidSet);

    if (uuids.length === 0) {
      this.translate.get(["excel.project", "excel.all-projects"]).pipe(take(1)).subscribe(resp => {
        const title = travel
          ? resp["excel.project"] + travelsToExport[0].title + (this.isAdmin ? "" : ` (${this.user.name} ${this.user.lastname})`)
          : resp["excel.all-projects"] + (this.isAdmin ? "" : `${this.user.name} ${this.user.lastname}`);

        this.excelService.createProjectsExcel(
          title,
          travelsToExport,
          this.isAdmin && this.isCompanyBookeds,
          this.user ? this.user.uuid : null
        );
      });
      return;
    }

    const requests = uuids.map(id =>
      this.userService.getUserByUuid(id).pipe(
        take(1),
        map((user: any) => ({ id, user })),
        catchError(() => of({ id, user: null }))
      )
    );

    this.subscriptions.push(
      forkJoin(requests).subscribe({
        next: pairs => {
          const usersByUuid: { [uuid: string]: any } = {};
          pairs.forEach(({ id, user }) => { if (user) usersByUuid[id] = user; });
          const users = Object.values(usersByUuid);
          travelsToExport.forEach(t => {
            t.usersByUuid = usersByUuid;
            t.users = users;
          });

          this.translate.get(["excel.project", "excel.all-projects"]).pipe(take(1)).subscribe(resp => {
            const title = travel
              ? resp["excel.project"] + travelsToExport[0].title + (this.isAdmin ? "" : ` (${this.user.name} ${this.user.lastname})`)
              : resp["excel.all-projects"] + (this.isAdmin ? "" : `${this.user.name} ${this.user.lastname}`);

            this.excelService.createProjectsExcel(
              title,
              travelsToExport,
              this.isAdmin && this.isCompanyBookeds,
              this.user ? this.user.uuid : null
            );
          });
        },
        error: () => {
          this.translate.get(["excel.project", "excel.all-projects"]).pipe(take(1)).subscribe(resp => {
            const title = travel
              ? resp["excel.project"] + travelsToExport[0].title + (this.isAdmin ? "" : ` (${this.user.name} ${this.user.lastname})`)
              : resp["excel.all-projects"] + (this.isAdmin ? "" : `${this.user.name} ${this.user.lastname}`);

            this.excelService.createProjectsExcel(
              title,
              travelsToExport,
              this.isAdmin && this.isCompanyBookeds,
              this.user ? this.user.uuid : null
            );
          });
        }
      })
    );
  }

  canExportBonus(travel) {
    const filterByUser = (b) =>
      Array.isArray(b.userUuid) ? b.userUuid.includes(this.uuidUser) : b.userUuid === this.uuidUser;
  
    const bookings = this.isAdmin ? travel.bookings : travel.bookings.filter(filterByUser);
    const customBookings = this.isAdmin ? travel.customBookings : travel.customBookings.filter(filterByUser);
    const expenses = this.isAdmin ? travel.expenses : travel.expenses.filter(filterByUser);
    const cars = this.isAdmin ? travel.cars : travel.cars.filter(filterByUser);
    const flights = this.isAdmin ? travel.flights : travel.flights.filter(filterByUser);
    const trains = this.isAdmin ? travel.trains : travel.trains.filter(filterByUser);
  
    return (
      bookings.length > 0 ||
      customBookings.length > 0 ||
      cars.length > 0 ||
      flights.length > 0 ||
      trains.length > 0 ||
      expenses.length > 0
    );
  }

  async exportBonus(travel) {
    this.travelService.getTravelBonus(travel.uuid).subscribe(async (res) => {
      const zip = new JSZip();
      for (let i = 0; i < res.length; i++) {
        const arr = new Uint8Array(res[i].data);
        const data: Blob = new Blob([arr], { type: 'application/pdf' })
        zip.file(`bono-${i + 1}.pdf`, data);
        if (i === res.length - 1) {
          await zip
            .generateAsync({ type: "blob" })
            .then(async function (content) {
              await saveAs(content, `bonos-${travel.title}.zip`);
            });
        }
      }
      if(res.length == 0){
        this.translate
          .get("flight-train.no-proyect-bono")
          .pipe(take(1))
          .subscribe((result) => {
            this.ngxToastrService.typeInfo(result, '');
          });
      }
    });
  }

  getPaginatorData(
    event: PageEvent
  ): PageEvent {
    this.travelPage =
      event.pageIndex + 1;

    this.travelPageSize =
      event.pageSize;

    this.loadTravels();

    return event;
  }

  onDateSelection(date: NgbDate) {
    if (
      !this.createdFromDate &&
      !this.createdToDate
    ) {
      this.createdFromDate = date;
    } else if (
      this.createdFromDate &&
      !this.createdToDate &&
      date.after(this.createdFromDate)
    ) {
      this.createdToDate = date;
      this.createdInput.close();

      this.createdAtRange.nativeElement.value =
        this.ngbDateParser.format(
          this.createdFromDate
        ) +
        ' a ' +
        this.ngbDateParser.format(
          this.createdToDate
        );
    } else {
      this.createdToDate = null;
      this.createdFromDate = date;

      this.createdAtRange.nativeElement.value =
        this.ngbDateParser.format(
          this.createdFromDate
        );
    }

    this.travelPage = 1;

    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }

    this.loadTravels();
  }

  setPage(): void {
    this.travelPage = 1;

    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }

    this.loadTravels();
  }

  isHovered(date: NgbDate) {
    return (
      this.createdFromDate &&
      !this.createdToDate &&
      this.hoveredDate &&
      date.after(this.createdFromDate) &&
      date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return (
      date.after(this.createdFromDate) && date.before(this.createdToDate)
    );
  }

  isRange(date: NgbDate): boolean {
    return (
      date.equals(this.createdFromDate) ||
      date.equals(this.createdToDate)
    );
  }

  private parsePrice(value: any): number {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  private getProjectItemPrice(item: any, type: string): number {
    switch (type) {
      case 'flight':
        return this.parsePrice(
          item?.price?.individualPrice ??
          item?.price?.totalPrice ??
          item?.price
        );

      case 'train':
        return this.parsePrice(
          item?.price?.total ??
          item?.price
        );

      case 'expense':
      case 'car':
        return this.parsePrice(
          item?.price ??
          item?.amount
        );

      default:
        return this.parsePrice(item?.price);
    }
  }

  projectTotal(project: any): number {
    let total = 0;

    const addItems = (items: any[], type: string) => {
      (items ?? [])
        .filter(item => !item?.deleted)
        .forEach(item => {
          total += this.getProjectItemPrice(item, type);
        });
    };

    if (project?.bookingFromModule?.length) {
      addItems(project.bookingFromModule, 'booking');
    } else {
      addItems(project?.bookings, 'booking');
    }

    addItems(project?.flights, 'flight');
    addItems(project?.trains, 'train');
    addItems(project?.expenses, 'expense');
    addItems(project?.cars, 'car');
    addItems(project?.customBookings, 'custom-booking');

    return Math.round((total + Number.EPSILON) * 100) / 100;
  }

  loadTravels(forceRefresh = false) {
    const params =
      this.buildTravelRequestParams();

    if (forceRefresh) {
      this.travelPagesCache.clear();
    }

    const cacheKey =
      this.getTravelCacheKey(params);

    const cachedResult =
      this.travelPagesCache.get(cacheKey);

    if (cachedResult && !forceRefresh) {
      this.applyTravelsResult(cachedResult);
      return;
    }

    this.isLoadingTravel = true;

    this.travelService
      .getTravelsWithParams(params)
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.isLoadingTravel = false;
        })
      )
      .subscribe({
        next: (result: any) => {
          this.travelPagesCache.set(
            cacheKey,
            result
          );

          this.applyTravelsResult(result);
        },
        error: (err) => {
          this.translate
            .get(
              'company.booked.error-get-booked'
            )
            .subscribe((message) => {
              this.ngxToastrService.typeInfo(
                message,
                err?.error?.error ||
                  err?.error?.message ||
                  err?.message
              );
            });
        },
      });
  }

  goBack() {
    this._location.back();
  }

  seeBookings(travel): void {
    this.isLoadingTravel = true;

    travel.bookings.forEach((booking: any) => {
      const relatedBooking = travel.bookingFromModule.find((bfm: any) => bfm.uuid === booking.bookedApiUuid);
      if (relatedBooking) {
        booking.checkIn = relatedBooking.checkIn;
        booking.checkOut = relatedBooking.checkOut;
        if (relatedBooking.status) booking.status = relatedBooking.status;
      }
    });

    const allReservations = [
      ...travel.bookings.map((b: any) => ({ ...b, type: 'Hotel' })),
      ...travel.flights.map((f: any) => ({ ...f, type: 'Flight' })),
      ...travel.cars.map((c: any) => ({ ...c, type: 'Car' })),
      ...travel.expenses.map((e: any) => ({ ...e, type: e.type })),
      ...travel.customBookings.map((cb: any) => ({ ...cb, type: 'CustomBooking' })),
      ...travel.trains.map((t: any) => ({ ...t, type: 'Train' }))
    ];

    const isMultiUserType = (t: string) => t === 'Hotel' || t === 'CustomBooking';

    const uuidSet = new Set<string>();
    for (const r of allReservations) {
      const raw = r?.userUuid;
      if (Array.isArray(raw)) {
        if (isMultiUserType(r.type)) {
          raw.forEach(id => id && uuidSet.add(id));
        } else if (raw[0]) {
          uuidSet.add(raw[0]);
        }
      } else if (raw) {
        uuidSet.add(raw);
      }
    }
    const uuids = Array.from(uuidSet);

    if (uuids.length === 0) {
      this.isLoadingTravel = false;
      const dialogRef = this.dialog.open(TravelBookingsModalComponent, {
        width: '80%',
        data: { allReservations, travelTitle: travel.title }
      });
      dialogRef.afterClosed().subscribe(() => {});
      return;
    }

    const requests = uuids.map(id =>
      this.userService.getUserByUuid(id).pipe(
        map((user: User) => ({ id, user })),
        catchError(() => of({ id, user: null }))
      )
    );

    const clean = (s: any) =>
      (s == null ? '' : String(s))
        .replace(/[\r\n\t]+/g, ' ')
        .replace(/\s{2,}/g, ' ')
        .trim();

    forkJoin(requests).subscribe({
      next: results => {
        const usersByUuid: { [id: string]: User } = {};
        results.forEach(({ id, user }) => { if (user) usersByUuid[id] = user; });

        for (const r of allReservations) {
          const raw = r?.userUuid;

          if (isMultiUserType(r.type)) {
            const ids = Array.isArray(raw) ? raw : (raw ? [raw] : []);
            const names: string[] = [];
            for (const id of ids) {
              const u = id ? usersByUuid[id] : null;
              const fullRaw = u
                ? (u.name && u.lastname) ? `${u.name} ${u.lastname}` : (u.name || '')
                : '';
              const full = clean(fullRaw);
              if (full) names.push(full.toUpperCase());
            }
            r.author = names.length ? names.join('\n') : (r.author || '-');
          } else {
            const id = Array.isArray(raw) ? raw[0] : raw;
            const u = id ? usersByUuid[id] : null;
            const fullRaw = u
              ? (u.name && u.lastname) ? `${u.name} ${u.lastname}` : (u.name || '')
              : '';
            const full = clean(fullRaw);
            if (full) r.author = full.toUpperCase();
          }
        }

        this.isLoadingTravel = false;
        const dialogRef = this.dialog.open(TravelBookingsModalComponent, {
          width: '80%',
          data: { allReservations, travelTitle: travel.title }
        });
        dialogRef.afterClosed().subscribe(() => {});
      },
      error: () => {
        this.isLoadingTravel = false;
        const dialogRef = this.dialog.open(TravelBookingsModalComponent, {
          width: '80%',
          data: { allReservations, travelTitle: travel.title }
        });
        dialogRef.afterClosed().subscribe(() => {});
      }
    });
  }

  canSeeBookings(travel) {
    const allBookings = [
      ...travel.bookings,
      ...travel.flights,
      ...travel.cars,
      ...travel.expenses,
      ...travel.customBookings,
      ...travel.trains
    ];

    return allBookings.length > 0;
  }

  addTravel(){
    const data = {
      create: true,
      isOnlyCreate: true,
      companyUuid: this.companyUuid,
      fromAdmin: true
    };
    const modalRef = this.dialog.open(DialogAssignProjectComponent, {
      data: data,
      panelClass: "new-dialog",
    });
    modalRef.afterClosed().subscribe((result) => {
      if (result != null) {
        if (this.companyUuid !== null) {
          result.travelData["companyUuid"] = this.companyUuid;
        }
        if (
          result.travelData["endDate"] === "" &&
          result.travelData["initDate"] === ""
        ) {
          delete result.travelData["endDate"];
          delete result.travelData["initDate"];
        }
        this.subscriptions.push(
          this.travelService.postTravel(result.travelData).subscribe(
            () => {
              this.subscriptions.push(
                this.translate
                  .get(`project.my-projects.created`)
                  .subscribe((resp) => {
                    this.ngxToastrService.typeSuccess(null, resp);
                    setTimeout(() => {
                        this.loadTravels(true);
                    }, 3000);
                  })
              );
            },
            (err) => {
              this.subscriptions.push(
                this.translate.get("common.error").subscribe((resp) => {
                  this.ngxToastrService.typeInfo(resp, err.error.message);
                })
              );
            }
          )
        );
      }
    });
  }

  private toApiDate(
    date: NgbDateStruct | null
  ): string | undefined {
    if (!date) {
      return undefined;
    }

    const month = String(date.month).padStart(2, '0');
    const day = String(date.day).padStart(2, '0');

    return `${date.year}-${month}-${day}`;
  }

  private buildTravelRequestParams(): any {
    const companyUuid =
      this.companyUuidSaved ||
      this.companyUuid;

    const params: any = {
      paginated: true,
      page: this.travelPage,
      pageSize: this.travelPageSize,
      sort: '-createdAt',
    };

    if (companyUuid) {
      params.companyUuid = companyUuid;
    }

    if (
      this.uuidUser &&
      !this.isCompanyBookeds
    ) {
      params.userUuid = this.uuidUser;
    }

    const title = String(
      this.f.title.value || ''
    ).trim();

    if (title) {
      params.title = title;
    }

    const createdFromDate = this.toApiDate(
      this.createdFromDate
    );

    const createdToDate = this.toApiDate(
      this.createdToDate
    );

    if (createdFromDate) {
      params.createdFromDate =
        createdFromDate;
    }

    if (createdToDate) {
      params.createdToDate =
        createdToDate;
    }

    return params;
  }

  private getTravelCacheKey(
    params: any
  ): string {
    return JSON.stringify({
      companyUuid: params.companyUuid || '',
      userUuid: params.userUuid || '',
      page: Number(params.page) || 1,
      pageSize: Number(params.pageSize) || 6,
      title: String(params.title || '')
        .trim()
        .toLowerCase(),
      createdFromDate:
        params.createdFromDate || '',
      createdToDate:
        params.createdToDate || '',
    });
  }

  private applyTravelsResult(
    result: any
  ): void {
    this.travels = result?.docs || [];

    this.travelPage =
      result?.page || 1;

    this.travelPageSize =
      result?.limit || 6;

    this.travelTotalDocs =
      result?.totalDocs || 0;

    this.travelTotalPages =
      result?.totalPages || 0;

    this.travelPagination = {
      page: this.travelPage,
      limit: this.travelPageSize,
      totalDocs: this.travelTotalDocs,
      totalPages: this.travelTotalPages,
      hasNextPage:
        result?.hasNextPage || false,
      hasPrevPage:
        result?.hasPrevPage || false,
    };
  }

  onTitleFilterChange(): void {
    this.titleFilterSubject.next();
  }

  ngOnDestroy(): void {
    this.travelPagesCache.clear();

    this.subscriptions.forEach(
      (subscription) =>
        subscription.unsubscribe()
    );

    this.bookService.clearCache();
  }

}
